import { render, staticRenderFns } from "./loudnew.vue?vue&type=template&id=697242b1"
import script from "./loudnew.vue?vue&type=script&lang=js"
export * from "./loudnew.vue?vue&type=script&lang=js"
import style0 from "./loudnew.vue?vue&type=style&index=0&id=697242b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports